import { type ReactElement, type ReactNode } from 'react';
import { Card, CardContent } from '@citibox-panel/ui';
import { PageHeader } from '../../../components/PageHeader';
import type { ExclusionListCarrier, ExclusionListSeams } from '../lib/excludedUser';
import { CarrierExclusionSection } from './CarrierExclusionSection';
import { PageIntro } from './PageIntro';

export interface CarrierExclusionListsPageProps extends ExclusionListSeams {
  brandLabel: string;
  brandDegraded: boolean;
  headerEnd?: ReactNode;
  // The catalog of carriers that have a list, in display order. The host owns it.
  carriers: readonly ExclusionListCarrier[];
  // The panel's own IANA zone for the «Desde» column; `null` renders in UTC.
  timeZone: string | null;
}

// Reached by direct URL and hanging off no navigation, so it carries its own chrome. Everything in
// it is filled by the host: this module resolves no config and knows no route. It opens no `main`
// landmark — the host's authenticated layout already does.
export function CarrierExclusionListsPage({
  brandLabel,
  brandDegraded,
  headerEnd,
  carriers,
  timeZone,
  fetchExcludedUsers,
  addExcludedUser,
  removeExcludedUser,
}: CarrierExclusionListsPageProps): ReactElement {
  return (
    <>
      <PageHeader brandLabel={brandLabel} brandDegraded={brandDegraded} headerEnd={headerEnd} />
      {/* One white, rounded panel for everything the page itself says, the same surface, inset and
          padding as door-access and every other card at this level. */}
      <Card variant="outlined" sx={{ borderRadius: 3, m: 2 }}>
        <CardContent>
          <PageIntro />
          {carriers.map((carrier) => (
            <CarrierExclusionSection
              key={carrier.slug}
              carrier={carrier}
              timeZone={timeZone}
              fetchExcludedUsers={fetchExcludedUsers}
              addExcludedUser={addExcludedUser}
              removeExcludedUser={removeExcludedUser}
            />
          ))}
        </CardContent>
      </Card>
    </>
  );
}
